<template>
    <div>
      <div @click="navigateToAdminView()" style="cursor: pointer;">
        <b-icon icon="chevron-left" class="mt-3"></b-icon>&nbsp;Zurück
      </div>
  
      <b-card header="Termin erstellen" class="mt-3">
        <b-form-group id="text">
          <label>Bezeichnung</label>
          <b-form-input
            v-model="text"
            type="text"
            placeholder="Bezeichnung eingeben..."
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group id="date" class="mt-3">
          <label>Datum</label>
          <b-form-input
            v-model="date"
            type="date"
            placeholder="Datum auswählen..."
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group id="date" class="mt-3">
          <label>Beschreibung</label>
          <b-form-textarea
            id="description"
            v-model="description"
            placeholder="Beschreibung eingeben..."
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-form-group>
        <!--b-form-group id="date" class="mt-3">
          <label>Wird Mittagessen benötigt?</label>
          <b-form-checkbox
            id="activeNeedLunch"
            v-model="activeNeedLunch"
          >
          </b-form-checkbox>
        </b-form-group!-->
        <b-button variant="danger" class="mt-3" @click="createAttendance()"
          >Termin erstellen</b-button
        >
      </b-card>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  
  export default {
    name: "newAttendanceView",
    data() {
      return {
        text: null,
        date: null,
        description: null,
        activeNeedLunch: true,

        apiUrl: process.env.VUE_APP_API_URL,
      };
    },
    methods: {
      navigateToAdminView() {
        this.$router.push(`/account/admin`);
      },
  
      createAttendance() {
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });
  
        const body = {
          text: this.text,
          date: this.date,
          description: this.description,
          activeNeedLunch: false //this.activeNeedLunch
        };
  
        axios
          .post(this.apiUrl + "/account/admin/new-attendance", body)
          .then(async (response) => {
            Toast.fire({
              icon: "success",
              title: "Termin erstellt",
            });
  
            console.log(response.data);
            this.$router.push("/account/admin");
          });
      },
    },
  };
  </script>
  
  <style scoped></style>
  